import { render, staticRenderFns } from "./metatag-form.vue?vue&type=template&id=23c67bc4&scoped=true&"
import script from "./metatag-form.vue?vue&type=script&lang=js&"
export * from "./metatag-form.vue?vue&type=script&lang=js&"
import style0 from "./metatag-form.vue?vue&type=style&index=0&id=23c67bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c67bc4",
  null
  
)

export default component.exports